module.exports = __webpack_public_path__ + "img/02_C_T.dd0861f4.png";